<script setup>
import { computed, ref, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useCarUsersGroupsStore } from '@/stores/car-users-groups'
import Modal from '@/components/UTAModal.vue'
import UTACarUsersGroup from '@/components/car/UTACarUsersGroup.vue'
import UTACarUsersGroupsCreate from '@/components/car/UTACarUsersGroupsCreate.vue'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const translaterStore       = useTranslaterStore()
const carUsersGroupsStore   = useCarUsersGroupsStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const carUsersGroups            = computed(() => carUsersGroupsStore.carUsersGroups)
const carUsersGroupsProcess     = computed(() => carUsersGroupsStore.carUsersGroupsProcess)
const carUsersGroupsMsg         = computed(() => carUsersGroupsStore.carUsersGroupsMsg)
const carUsersGroupsCreateMsg   = computed(() => carUsersGroupsStore.carUsersGroupsCreateMsg)
const carUsersGroupsUpdateMsg   = computed(() => carUsersGroupsStore.carUsersGroupsUpdateMsg)
const carUsersGroupsDeleteMsg   = computed(() => carUsersGroupsStore.carUsersGroupsDeleteMsg)

const inputSearch = ref('')
const showCreateCarUsersGroups = ref(false)

carUsersGroupsStore.readCarUsersGroups({ car_array: props.uuid, 'c.limit': 6 })

// TODO: Чистка мусора на клиентах. Можно удалять 1 апреля 2024 года.
if(localStorage.getItem('UTA_CAR_USERS_GROUPS_VIEW')) {

    localStorage.removeItem('UTA_CAR_USERS_GROUPS_VIEW')
}

watch(carUsersGroupsCreateMsg, msg => {
    if('success' in msg && msg.success) {
        carUsersGroupsStore.readCarUsersGroups({ car_array: props.uuid, 'c.limit': 6 })
    }
})

watch(carUsersGroupsDeleteMsg, msg => {
    if('success' in msg && msg.success) {
        carUsersGroupsStore.readCarUsersGroups({ car_array: props.uuid, 'c.limit': 6 })
    }
})

watch(inputSearch, input => {
    input.length > 2 ? 
        carUsersGroupsStore.readCarUsersGroups({ car_array: props.uuid, 'c.limit': 6, 'c.q': inputSearch.value }) :
        carUsersGroupsStore.readCarUsersGroups({ car_array: props.uuid, 'c.limit': 6 })
})
</script>

<template>
    <div class="mb-4 uta-cars-group-users-groups">

        <header class="uta-page-header" role="heading" aria-level="1">
            <h1 class="uta-page-header__title">{{ getTranslate.CAR_RIGHTS_USERS_GROUPS }}</h1>
            <div class="uta-page-header__actions">
                <button 
                    class="uta-page-header__action uta-btn uta-btn--main uta-btn--sm uta-btn--has-icon" 
                    type="button" 
                    :title="getTranslate.BTN_CTRL"
                    @click="showCreateCarUsersGroups = true"
                >
                    <span class="uta-btn__content">
                        <span class="uta-btn__icon material-icons">settings</span>
                        <span class="uta-btn__text uta-btn__text--has-icon d-none d-md-block">{{ getTranslate.BTN_CTRL }}</span>
                    </span>
                </button>
            </div>
        </header>

        <div class="row mb-4 justify-content-between">
            <div class="col-12">
                <div class="uta-input__wrapper uta-search">
                    <input 
                        type="text" 
                        :placeholder="getTranslate.SEARCH + '...'" 
                        v-model="inputSearch"
                        @keyup.escape="inputSearch = ''"
                        class="form-control uta-input__wrapper-input uta-search__input" 
                    >
                    <template v-if="inputSearch.length > 2">
                        <span class="material-icons uta-input__wrapper-icon" @click="inputSearch = ''">
                            cancel
                        </span>
                    </template>
                    <template v-else>
                        <span class="material-icons uta-input__wrapper-icon">
                            search
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div 
            v-if="'success' in carUsersGroupsMsg && !carUsersGroupsMsg.success"
            class="uta-alert uta-alert--danger mb-4" 
        >
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersGroupsMsg.text] || carUsersGroupsMsg.text }}
            </div>
        </div>

        <div 
            v-if="'success' in carUsersGroupsUpdateMsg"
            class="uta-alert mb-4" 
            :class="{
                'uta-alert--success' : carUsersGroupsUpdateMsg.success, 
                'uta-alert--danger' : !carUsersGroupsUpdateMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">
                {{ carUsersGroupsUpdateMsg.success ? 'check_circle_outline' : 'error_outline' }}
            </span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersGroupsUpdateMsg.text] || carUsersGroupsUpdateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="carUsersGroupsStore.setCarUsersGroupsUpdateMsg({})">
                <span class="material-icons">
                    close
                </span>
            </button>
        </div>

        <div 
            v-if="'success' in carUsersGroupsDeleteMsg && carUsersGroupsDeleteMsg.success"
            class="uta-alert mb-4" 
            :class="{
                'uta-alert--success' : carUsersGroupsDeleteMsg.success, 
                'uta-alert--danger' : !carUsersGroupsDeleteMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">
                {{ carUsersGroupsDeleteMsg.success ? 'check_circle_outline' : 'error_outline' }}
            </span>
            <div class="uta-alert__text">
                {{ getTranslate[carUsersGroupsDeleteMsg.text] || carUsersGroupsDeleteMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="carsGroupStore.setCarUsersGroupsDeleteMsg({})"></button>
        </div>

        <template v-if="carUsersGroups.ugroups?.length">

            <div class="container-fluid">
                <div class="uta-car-users-groups__list uta-list">
                    <div class="uta-list__title d-none d-lg-block uta-car-users-groups__title">
                        <div class="row">
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-12 col-lg-5">{{ getTranslate.CAR_RIGHTS_USERS_GROUPS_NAME }}</div>
                                    <div class="col-12 col-lg-7">{{ getTranslate.CAR_RIGHTS_USERS_GROUPS_DESCR }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uta-list__content">
                        <div 
                            class="row align-items-center uta-list__item uta-car-users-groups__car uta-car-users-groups__car--lines" 
                            :class="{ 'uta-list__item--dark' : index % 2 }" 
                            v-for="(group, index) in carUsersGroups.ugroups" 
                            :key="group.uuid"
                        >
                            <UTACarUsersGroup :group="group" :uuid="uuid" :outerIndex="index" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="carUsersGroups.c?.isBefore || carUsersGroups.c?.isAfter">
                <div class="my-4 uta-pagination col-12 col-lg-6 col-xxl-4">
                    <div class="uta-pagination__prev" :class="{ 'uta-pagination__prev--active' : carUsersGroups.c.isBefore }">
                        <template v-if="carUsersGroups.c.isBefore">
                            <button 
                                type="button"
                                class="uta-pagination__prev-link" 
                                :disabled="carUsersGroupsProcess"
                                @click.prevent="prevPage(cars.c.start)"
                            >
                                <div class="uta-pagination__prev-link-spinner spinner-border text-secondary" role="status" v-if="carUsersGroupsProcess">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <span class="material-icons">
                                    chevron_left
                                </span>
                            </button>
                        </template>
                        <template v-else>
                            <span class="material-icons">
                                chevron_left
                            </span>
                        </template>
                    </div>
                    <div class="uta-pagination__page">
                        {{ pageNumber }}
                    </div>
                    <div class="uta-pagination__next" :class="{ 'uta-pagination__next--active' : carUsersGroups.c.isAfter }">
                        <template v-if="carUsersGroups.c.isAfter">
                            <button 
                                type="button"
                                class="uta-pagination__next-link" 
                                :disabled="carUsersGroupsProcess"
                                @click.prevent="nextPage(carUsersGroups.c.stop)"
                            >
                                <div class="uta-pagination__next-link-spinner spinner-border text-secondary" role="status" v-if="carUsersGroupsProcess">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <span class="material-icons" v-else>
                                    chevron_right
                                </span>
                            </button>
                        </template>
                        <template v-else>
                            <span class="material-icons">
                                chevron_right
                            </span>
                        </template>
                    </div>
                </div>
            </div>

        </template>

        <transition name="bounce">
            <Modal 
                v-if="showCreateCarUsersGroups"
                :header="getTranslate.CAR_RIGHTS_USERS_GROUPS_CREATE"
                size="md"
                @closeModal="showCreateCarUsersGroups = false"
            >

                <template v-slot:body>
                    <UTACarUsersGroupsCreate :uuid="uuid" @closeModal="showCreateCarUsersGroups = false" />
                </template>
            </Modal>
        </transition>

    </div>
</template>
